import {
  createFrontendPlugin,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';

const externalDependenciesSubPage = SubPageBlueprint.make({
  name: 'external-dependencies',
  attachTo: { id: 'page:devtools', input: 'pages' },
  params: {
    path: 'external-dependencies',
    title: 'External Dependencies',
    loader: async () => {
      const { ExternalDependenciesContent } = await import(
        '@backstage/plugin-devtools'
      );
      return compatWrapper(<ExternalDependenciesContent />);
    },
  },
});

const logsSubPage = SubPageBlueprint.make({
  name: 'logs',
  attachTo: { id: 'page:devtools', input: 'pages' },
  params: {
    path: 'logs',
    title: 'Logs',
    loader: async () => {
      const {
        BackstageLogs,
        DataSourceProvider,
        LoadingProvider,
      } = await import('@internal/backstage-plugin-grafana-observability-frontend');
      return compatWrapper(
        <DataSourceProvider>
          <LoadingProvider>
            <BackstageLogs />
          </LoadingProvider>
        </DataSourceProvider>,
      );
    },
  },
});

const rebacSubPage = SubPageBlueprint.make({
  name: 'rebac',
  attachTo: { id: 'page:devtools', input: 'pages' },
  params: {
    path: 'rebac',
    title: 'ReBAC',
    loader: async () => {
      const { RebacExplorerContent } = await import(
        '@internal/plugin-rebac-explorer-frontend'
      );
      return compatWrapper(<RebacExplorerContent />);
    },
  },
});

export const devtoolsCustomizationPlugin = createFrontendPlugin({
  pluginId: 'app-devtools-customization',
  extensions: [externalDependenciesSubPage, logsSubPage, rebacSubPage],
});
